module.exports = __webpack_public_path__ + "img/promo3.e1816814.png";